(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormCategoryMatrixController', EventFormCategoryMatrixController);

    EventFormCategoryMatrixController.$inject = ['EventFormCategory', 'AlertService'];

    function EventFormCategoryMatrixController(EventFormCategory, AlertService) {
        var vm = this;

        vm.showArchived = false;
        vm.toggleArchived = toggleArchived;
        vm.matrix = {
            baseFields: [],
            fields: [],
            rows: []
        };

        load();

        function load() {
            EventFormCategory.getMatrix({inclDeleted: vm.showArchived}, function(result) {
                vm.matrix = result || vm.matrix;
            }, function(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'Erreur lors du chargement de la matrice des formulaires.');
            });
        }

        function toggleArchived() {
            vm.showArchived = !vm.showArchived;
            load();
        }
    }
})();
